import React from "react";
import MainLogoWhite from '../images/MainLogoWhite.png';
import { Link } from "react-router-dom";

const Header = () => {
    return(
      <header className="header-logo">
      <Link to="/">
        <img src={MainLogoWhite} alt="Logo firmy KompLand" width="200" />
      </Link>
    </header>
    
    );

};

export default Header